import { HttpResponse } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { ProductLocationMap } from 'dm-src/dtos/product-location-map';
import { Observable } from 'rxjs';
import { FilteredPageQuery, ISelectOption } from 'shared';
export const PRODUCTPROVIDER_SERVICE_IMPL = new InjectionToken<IProductProviderService>(
    'productProviderServiceImpl'
);

export interface IProductProviderService {
    getShelfDisplayNameKeys(orderid: number): Observable<any>;
    getShelfPositionDisplayNameKeys(productproviderid: number, orderid: number);
    setProductLocationMap(
        productproviderid: number,
        productlocationmapid: string,
        orderid: number
    ): Observable<HttpResponse<ProductLocationMap>>;
    setShelfPositionDisplayNameKey(
        productproviderid: number,
        shelfpositiondisplaynamekey: string,
        orderid: number
    ): Observable<HttpResponse<ProductLocationMap>>;
}
